import { useState } from 'react';
import { XIcon } from 'lucide-react';
type Props = {
  /** Naam van het veld voor schermlezers (het zichtbare label staat in een `Field as="div"`, niet gekoppeld). */
  label: string;
  value: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
  /** Suggesties die met één klik toe te voegen zijn. */
  suggestions?: string[];
};

/** Vrije lijst van korte waarden: typ en druk op Enter. */
export function TagInput({
  label,
  value,
  onChange,
  placeholder = 'Typ en druk op Enter',
  suggestions = []
}: Props) {
  const [draft, setDraft] = useState('');
  const add = (raw: string) => {
    const v = raw.trim();
    if (v && !value.includes(v)) onChange([...value, v]);
    setDraft('');
  };
  const open = suggestions.filter(s => !value.includes(s));
  return <div data-id="element-5307" data-mp="2tw3wotvz86aq">
      <div className="flex min-h-[42px] flex-wrap items-center gap-1.5 rounded-md border border-line bg-white px-2 py-1.5 transition-colors duration-150 ease-soft focus-within:border-clay focus-within:ring-2 focus-within:ring-clay/15" data-id="element-5308" data-mp="2tvudpq9cmzej">
        {value.map(v => <span key={v} className="inline-flex items-center gap-1 rounded-full bg-sand py-1 pl-3 pr-1.5 text-[13px] text-ink" data-id="element-5309" data-mp="1379sp00hr6kp">
            {v}
            <button type="button" onClick={() => onChange(value.filter(x => x !== v))} aria-label={`${v} verwijderen`} className="rounded-full p-1.5 text-muted transition-colors duration-150 ease-soft hover:bg-line hover:text-ink sm:p-0.5" data-id="element-5310" data-mp="1c5byrtz30peu">
              <XIcon className="h-3 w-3" strokeWidth={2} aria-hidden="true" data-id="element-5311" data-mp="ogstlnbbwsqz" />
            </button>
          </span>)}
        <input aria-label={`${label}: typ en druk op Enter om toe te voegen`} value={draft} onChange={e => setDraft(e.target.value)} onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ',') {
          e.preventDefault();
          add(draft);
        } else if (e.key === 'Backspace' && !draft && value.length) {
          onChange(value.slice(0, -1));
        }
      }} onBlur={() => draft && add(draft)} placeholder={value.length ? '' : placeholder} className="min-w-[8rem] flex-1 bg-transparent px-1 py-1 text-[16px] text-ink placeholder:text-muted focus:outline-none sm:text-[14px]" data-id="element-5312" data-mp="tdsxbrkphjex" />
      </div>
      {open.length > 0 && <div role="group" aria-label={`Suggesties voor ${label.toLowerCase()}`} className="mt-2 flex flex-wrap gap-1.5" data-id="element-5313" data-mp="3auu3vfuck218">
          {open.map(s => <button key={s} type="button" onClick={() => add(s)} aria-label={`${s} toevoegen`} className="rounded-full border border-dashed border-line px-2.5 py-1 text-[12px] text-muted transition-colors duration-150 ease-soft hover:border-ink/40 hover:text-ink" data-id="element-5314" data-mp="36vv2g57tqnej">
              + {s}
            </button>)}
        </div>}
    </div>;
}